import { variant } from 'styled-system';

export const ButtonShapeArray = ['auto', 'rounded', 'rounded-square', 'circle'] as const;
type ButtonShapeTuple = typeof ButtonShapeArray;
export type ButtonShape = ButtonShapeTuple[number];

type ButtonShapeProps = {
    borderRadius: string;
};

export const shapeVariant = variant<ButtonShapeProps, ButtonShape>({
    prop: 'shape',
    variants: {
        auto: {
            borderRadius: '0',
        },
        rounded: {
            borderRadius: '12px',
        },
        // TODO: Remove
        'rounded-square': {
            borderRadius: '12px',
        },
        circle: {
            borderRadius: '50%',
        },
    },
});
